export default __webpack_public_path__ + "static/media/plusprimary.be20aa1a.svg";